// @flow
import moment from "moment"
import { Record } from "immutable"

import { DATE_FORMAT } from "../consts/date"
import { REQUIRE_PID } from "../../mmb/scenes/AccountBooking/components/Booking/components/BookingPendingRequests/consts/pendingRequestConsts"
import type { Input } from "../../mmb/scenes/AccountBooking/components/Booking/components/BookingPendingRequests/consts/pendingRequestConsts"

const PendingRequestRecord = Record({
  id: null,
  status: null,
  reason: null,
  created: null,
  fulfilled: null,
  note: null,
  // only on some reasons
  pid: null,
  passport: null,
})

class PendingRequest extends PendingRequestRecord {
  constructor(input: Input = {}) {
    if (REQUIRE_PID.includes(input.reason) && !input.pid && !input.passport) {
      throw new Error(`PendingRequest: pid and passport are required with reason ${input.reason}`)
    }

    const formatted = { ...input }
    formatted.created = moment(formatted.created * 1000).format(DATE_FORMAT)

    if (input.fulfilled && formatted.fulfilled) {
      formatted.fulfilled = moment(formatted.fulfilled * 1000).format(DATE_FORMAT)
    }

    super(formatted)
  }
}

export default PendingRequest
